export var ADD_USER_REQUEST = 'app/UserNew/ADD_USER_REQUEST';
export var ADD_USER_SUCCESS = 'app/UserNew/ADD_USER_SUCCESS';
export var ADD_USER_FAILURE = 'app/UserNew/ADD_USER_FAILURE';
export var IMPORT_EXCEL_REQUEST = 'app/UserNew/IMPORT_EXCEL_REQUEST';
export var IMPORT_EXCEL_SUCCESS = 'app/UserNew/IMPORT_EXCEL_SUCCESS';
export var IMPORT_EXCEL_FAILURE = 'app/UserNew/IMPORT_EXCEL_FAILURE';
export var DOWNLOAD_EXCEL_TEMPLATE_REQUEST = 'app/UserNew/DOWNLOAD_EXCEL_TEMPLATE_REQUEST';
export var DOWNLOAD_EXCEL_TEMPLATE_SUCCESS = 'app/UserNew/DOWNLOAD_EXCEL_TEMPLATE_SUCCESS';
export var DOWNLOAD_EXCEL_TEMPLATE_FAILURE = 'app/UserNew/DOWNLOAD_EXCEL_TEMPLATE_FAILURE';
